/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statsinviteshint2Inputs */

const en_statsinviteshint2 = /** @type {(inputs: Statsinviteshint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invites to another person. Join requests are not counted.`)
};

const de_statsinviteshint2 = /** @type {(inputs: Statsinviteshint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einladungen an eine andere Person. Beitrittsanfragen zählen nicht.`)
};

/**
* | output |
* | --- |
* | "Invites to another person. Join requests are not counted." |
*
* @param {Statsinviteshint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsinviteshint2 = /** @type {((inputs?: Statsinviteshint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsinviteshint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsinviteshint2(inputs)
	return de_statsinviteshint2(inputs)
});
export { statsinviteshint2 as "statsInvitesHint" }